export default class PermissionConstants {

		static DEFAULT_USER_ACTION_KIND = "DEFAULT";
		static DEFAULT_FILTER_KIND = "USE_DEFAULT";

}
